<div class="container">
  <div class="logo b2a">
    <img class="image" src="/assets/logos/4C_Logo_B2A_Claim2018.svg" alt="Back2Action">
    <p class="subline" >{{'LOGIN.logosubline' |translate}}</p>
  </div>

  <app-module>
    <div>
      <form class="login-container" [formGroup]="resetForm" (ngSubmit)="reset($event)">
        <app-introtext>
          <h1>{{'LOGIN.RESET.headerComplete' | translate}}</h1>
          <p>{{'LOGIN.RESET.subheaderComplete' | translate}}</p>
        </app-introtext>
        <app-input [error]="resetForm.controls['password'].invalid && resetForm.controls['password'].touched">
            {{'SIGNUP.STEP1.labelPassword' | translate}}
          <input [formControlName]="'password'" type="password" placeholder="{{'SIGNUP.STEP1.placeholderPassword' | translate}}">
          <div app-input-error *ngIf="resetForm.controls['password'].invalid && resetForm.controls['password'].touched">
              {{ 'GENERAL.FORMS.required' | translate }}
          </div>
        </app-input>
        <app-input [error]="resetForm.controls['confirmPassword'].invalid && resetForm.controls['confirmPassword'].touched">
            {{'SIGNUP.STEP1.labelPasswordRepeat' | translate}}
          <input [formControlName]="'confirmPassword'" type="password" placeholder="{{'SIGNUP.STEP1.placeholderPassword' | translate}}">
          <div app-input-error *ngIf="resetForm.controls['confirmPassword'].invalid && resetForm.controls['confirmPassword'].touched">
              {{ 'GENERAL.FORMS.passwordConfirmInvalid' | translate }}
          </div>
        </app-input>

        <button type="submit" mat-raised-button color="accent">{{'LOGIN.RESET.submitNewPasswordBtn' | translate}}</button>

        <div class="error" *ngIf="error.length !== 0">{{'LOGIN.RESET.ERROR.' + error | translate}}</div>
      </form>

    </div>
  </app-module>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/password-reset/password-reset.component.html